import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {GlossaryTerm} from "../types/GlossaryTerm";

interface Props {
    term: GlossaryTerm;
}

export const PricesGlossaryCard = (props: Props) => {
    const {term} = props;

    return (
        <div className={cardStyle}>
            <Text variant="headline_6" as="p" mb={1}>
                {term.title}
            </Text>

            <Text variant="body_copy_1" color="var(--colors-gray-700)">
                {term.description}
            </Text>
        </div>
    );
};

const cardStyle = css({
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    p: 2,
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-gray-200)",
    borderRadius: 3,

    md: {
        p: 3
    }
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {GlossaryTerm} from "../types/GlossaryTerm";

interface Props {
    term: GlossaryTerm;
}

export const PricesGlossaryCard = (props: Props) => {
    const {term} = props;

    return (
        <div className={cardStyle}>
            <Text variant="headline_6" as="p" mb={1}>
                {term.title}
            </Text>

            <Text variant="body_copy_1" color="var(--colors-gray-700)">
                {term.description}
            </Text>
        </div>
    );
};

const cardStyle = css({
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    p: 2,
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-gray-200)",
    borderRadius: 3,

    md: {
        p: 3
    }
});
